import React from 'react';
import { Button } from "@mui/material";

export const NavigationButtons = ({ item, selectedButton, handleButtonClick, documentID }) => {
  return (
    <Button
      key={item.id}
      variant={selectedButton === item.id ? "contained" : "outlined"}
      startIcon={item.icon}
      onClick={() => handleButtonClick(item.id)}
      disabled={!documentID && !["General", "Usuarios", "Clipping", "Complemento DOC", "Documentos"].includes(item.name)}
      fullWidth
      style={{ marginBottom: "10px", padding: "9px", borderRadius: "8px" }}
    >
      <span style={{ width: "80px" }}>
        {item.name}
      </span>
    </Button>
  )
}
